import ga from '../utils/ga'

export const reportAutoSuggest = (payload: {
  suggestedTerm: string[]
  label: string
  action: string
}) => {
  ga('set', {
    metric2: payload.suggestedTerm.length,
    metric3: payload.label.length,
    dimension16: payload.suggestedTerm.join(',')
  })
  ga(
    'send',
    'event',
    'autosuggestion',
    payload.action || 'click',
    payload.label
  )
}
